function PageHeading({ id, label, title, description }) {
  return (
    <div className="page-heading">
      <span className="section-kicker">{label}</span>
      <h1 id={id}>{title}</h1>
      <p>{description}</p>
    </div>
  );
}

export default PageHeading;
